import { Component } from 'react';

import firebase from 'firebase/app';
import moment from 'moment';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { appDone, appWait } from '../../store/actions/app.js';

import { delivDone,
         deliveriesConnect, 
         deliveriesDisconnect, 
         deliveriesUpdate } from '../../store/actions/deliveries.js';

import { orderDone,
         ordersUpdate } from '../../store/actions/orders.js';

//*******************
class ServDeliv extends Component{
    constructor(props){
        super(props);

//*** Instance Variables
        this.delivDisconect = null;

//*** State
        this.state={};
    }
    
    componentWillUpdate(nextProps){
        if (nextProps.delivState !== this.props.delivState){
            this._handleUpdates(nextProps);
        }
        if (nextProps.ordersState !== this.props.ordersState){
            this._handleUpdates(nextProps);
        }
    }
    
    render(){
        return null;
    }

    //********************************
    _handleUpdates(nextProps){
        switch (nextProps.delivState) {
            case 1:
                this._delivConnect();
                break;

            case 4:
                this._delivDisconnect();
                break;

            case 5:
                setTimeout(()=>{    
                    this._delivStart();
                },0);
                break;

            case 6:
                setTimeout(()=>{
                    this._delivStartUpd();
                },0);
                break;

            default:
                break;
        }

        switch (nextProps.ordersState) {
            case 1:
                this._orderStatusUpdate(1);
                break;

            case 2:                
                this._orderStatusUpdate(0);
                break;

            default:
                break;
        }
    }

    //********************************
    _delivConnect(){
        if (this.delivDisconect){ 
            this.delivDisconect();            
        }

        this.props.appWait();
        
        this.delivDisconect = 
            firebase.firestore().collection("deliveries")
            .where('branch','==',this.props.branch)
            .where('plate_id','==',this.props.plate)
            .where('_status_update','>',new Date(new Date() - 30*1000*60*60*24))
            .onSnapshot(qSnap=>{
                let changes = [];
                qSnap.docChanges().forEach(i=>{
                    changes.push(i.doc.data());
                });

                let all = [];
                qSnap.forEach(deliv=>{
                    all.push(deliv.data());
                });

                all = all.sort((p,n)=>{
                    return parseInt(p.delivery,10) < parseInt(n.delivery,10)?1:-1;
                });

                this.props.delivUpdate(all);

                changes.forEach(i=>{
                    this.props.ordersUpdate({
                        delivery: i,
                        orders: i.orders
                    });    
                });

                this.props.appDone();
            },err=>{
                this.props.appDone();
                console.log(err);
                this._delivDisconnect();
            });        
    }

    _delivDisconnect(){
        if (this.delivDisconect){ 
            this.delivDisconect();
        }
        this.delivDisconect = null;
    }

    async _delivStart(){
        const data = {
            "delivery_start_date": new Date()
        }

        await firebase.firestore().collection("deliveries")
            .doc(this.props.delivKey).update(data);
        
        this.props.delivDone();
    }

    async _delivStartUpd(){
        const _key = this.props.delivKey;
        const _date = moment(this.props.delivStartDate).toDate();

        if (!_key || !_date) return;
        
        await firebase.firestore().collection("deliveries").doc(_key)
            .update({"delivery_start_date":_date});
        
        this.props.delivDone();
    }

    async _orderStatusUpdate(status){
        const delivKey = this.props.ordersDeliv._key;
        let deliv = {};

        const doc = 
            await firebase.firestore()
                .collection("deliveries").doc(delivKey).get();

        if (doc.exists){
            deliv = doc.data();
        }

        if (!deliv.orders){
            this.props.orderDone();
            return;            
        }
        
        let sensor;
        const qSnap = await firebase.firestore().collection("sensors")
            .where('uin','==',parseInt(deliv.sensor_uin,10)).get();
        qSnap.forEach(s=>{
            sensor = s.data();
        });

        let _delivOrders = deliv.orders;
        let timestamp = new Date();
        let orderData = this.props.orderData;

        _delivOrders = _delivOrders.map(i=>{
            if (i.order_id === orderData.order){
                if (i._status !== status){
                    i._status = status;
                }
                i.note = orderData.note;
                if (sensor){
                    i.lat = sensor.lat;
                    i.lng = sensor.lng;    
                }

                if (orderData.date){
                    let _moment = moment(orderData.date);

                    if (_moment.isValid()){
                        i._status_update = _moment.toDate();
                    }
                } else {
                    i._status_update = timestamp;
                }
            }
            return i;
        });

        if (_delivOrders.length === 0){
            return;
        }

        let someDelivered = false;
        let allDelivered = true; 
        
        deliv.orders.forEach(i=>{
            if (i._status === 1){
                someDelivered = true;
            } else {
                allDelivered = false;
            }
        });

        deliv._status = 0;
        if (someDelivered){
            deliv._status = 1;    
        }
        if (allDelivered){
            deliv._status = 2;    
        }
        
        deliv._status_update = timestamp;
        deliv.orders = _delivOrders;

        await firebase.firestore()
            .collection("deliveries").doc(delivKey).set(deliv);
        this.props.orderDone();
    }
}

const mapStateToProps = state => {
    return {
        branch: state.profile.branch,

        deliveries: state.deliveries.deliveries,
        delivState: state.deliveries.delivState,
        delivKey: state.deliveries.key,
        delivStartDate: state.deliveries.startDate,

        plate: state.app.plate,

        ordersDeliv: state.orders.ordersDeliv,
        orderData: state.orders.orderData,
        ordersState: state.orders.ordersState,

        user: state.profile.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appDone: () => dispatch(appDone()),
        appWait: () => dispatch(appWait()),

        delivConnect: data => dispatch(deliveriesConnect(data)),
        delivDisconnect: data => dispatch(deliveriesDisconnect(data)),
        delivDone: () => dispatch(delivDone()),
        delivUpdate: data => dispatch(deliveriesUpdate(data)),

        orderDone: data => dispatch(orderDone(data)),
        ordersUpdate: data => dispatch(ordersUpdate(data))
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(ServDeliv));


// WEBPACK FOOTER //
// ./src/containers/Cservices/ServDeliv.js